<template lang="pug">
	.search
		portal(to="modal-outlet")
			SearchModal(modal-id="search-modal", :modal-view="modalView")
				h1(slot="modal-header") Szűrés
				SearchForm(slot="modal-body", :redirect="redirect", :modal-view="modalView")
		VueButton.search__filter-button(v-if="modalView && isMobile", buttonType="highlighted", @click="openSearchModal") {{$t('ALIST.filter')}}
</template>
<script>
import SearchForm from './components/search-form';
import SearchModal from './components/search-modal';
import VueButton from '@ui-common/vue-button';
import isMobile from '../../common/js/is-mobile/is-mobile';
export default {
	mixins: [isMobile],
	props: {
		redirect: {
			type: Boolean,
			default: true
		},
		modalView: {
			type: Boolean,
			required: true
		}
	},
	components: {
		SearchForm,
		SearchModal,
		VueButton
	},
	methods: {
		openSearchModal(e) {
			this.$openModal(e, 'search-modal');
		}
	}
};
</script>
<style lang="css" scoped>
.search__filter-button {
	bottom: 7px;
    font: normal 16px semibold,Arial,sans-serif;
	margin: 0 8px;
	padding: 12px;
	position: fixed;
	width: calc(100% - 16px);
	z-index: 100;
	border-radius: 4px;
}
</style>
